import React from "react";

const LocationInventory = ({ data = [] }) => {

    const quantities = data.map(d => Number(d.quantity) || 0);
    const maxQty = quantities.length ? Math.max(...quantities, 1) : 1;
    return (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden mb-3">

            <div className="px-4 py-2 border-b border-gray-100 flex justify-between items-center">
                <h6 className="text-sm font-semibold text-gray-800">
                    Inventory
                </h6>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full text-sm">

                    <thead className="bg-gray-50 text-gray-500 text-xs">
                        <tr>
                            <th className="text-left px-4 py-2 font-medium">Grade</th>
                            <th className="text-left px-4 py-2 font-medium">Location</th>
                            <th className="text-right px-4 py-2 font-medium">Qty</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((item, index) => {
                            const percent = (item.quantity / maxQty) * 100;

                            return (
                                <tr key={index} className="group hover:bg-gray-50 transition">

                                    <td className="px-4 py-2 font-medium text-gray-800">
                                        {item.grade}
                                    </td>

                                    <td className="px-4 py-2 text-gray-500">
                                        {item.location}
                                    </td>

                                    <td className="px-4 py-2 text-right">
                                        <div className="flex flex-col items-end gap-1">
                                            <span className="font-semibold text-gray-900">
                                                {item.quantity}
                                            </span>

                                            <div className="w-20 h-1 bg-gray-100 rounded-full overflow-hidden">
                                                <div
                                                    className="h-full rounded-full transition-all duration-300"
                                                    style={{
                                                        width: `${percent}%`,
                                                        background: "var(--base-color)"
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </td>

                                </tr>
                            );
                        })}
                    </tbody>

                </table>
            </div>
        </div>
    );
};

export default LocationInventory;